const { atom } = require("recoil");

export const targetSkillScoreState = atom({
  key: "targetSkillScoreState",
  default: {}
});

export const checkinsDropDownState = atom({
  key: "checkinsDropDownState",
  default: []
});

export const skillNameState = atom({
  key: "skillNameState",
  default: []
});
